import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateRendererComponent } from './template-renderer.component';

@NgModule({
  declarations: [TemplateRendererComponent],
  imports: [
    CommonModule
  ],
  exports: [TemplateRendererComponent]
})
export class TemplateRendererModule { }